function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M19.4 10.53c.52-.1.88.49.56.91l-6.95 8.85c-.35.45-1.07.16-1.01-.4l.7-7.6c.02-.25.21-.46.46-.51l6.24-1.25zm2.24-2.84c.22.24.1.63-.21.7l-8.44 1.69c-.55.11-.91-.56-.51-.96L17.5 4.1c.23-.23.6-.22.82.01l3.32 3.58zm-6.95-4.5c.47.06.66.63.33.97l-3.56 3.56c-.21.21-.55.22-.78.02L5.34 2.99c-.42-.37-.1-1.06.45-.99l8.9 1.19zm-3.97 6.88c.27.24.4.59.38.94l-.86 10.46c-.05.6-.88.72-1.1.16L2.29 3.96c-.22-.56.46-1.03.91-.63l7.52 6.74z"
})));